function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.824 1.943a2.43 2.43 0 100 4.86 2.43 2.43 0 000-4.86zM8 1.796A3.373 3.373 0 108 6.95a3.373 3.373 0 100-5.154zm.629.703c.359.536.568 1.18.568 1.874 0 .693-.21 1.338-.568 1.874a2.43 2.43 0 100-3.748zM5.824 9.922a3.88 3.88 0 00-3.881 3.881v.254h7.762v-.254a3.88 3.88 0 00-1.94-3.362h-.003a3.863 3.863 0 00-1.938-.519zM8 9.497a4.824 4.824 0 00-7 4.306v.726c0 .26.211.471.472.471h13.056c.26 0 .472-.211.472-.472v-.725a4.824 4.824 0 00-7-4.306zm.942.626a4.813 4.813 0 011.706 3.68v.254h3.409v-.254a3.88 3.88 0 00-5.115-3.68z",
  fill: "#2D2D2D"
});
function SvgPersonasusuarias(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Personas usuarias.svg";
export { SvgPersonasusuarias as ReactComponent };